import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";
import apiUrl from "../../environment/Api";
import { toast } from "react-toastify";
import "../../assets/css/updelete.css";
import "../../assets/css/user.css";
import { Link } from "react-router-dom";
import Select from "react-select";
import ActionsDropdown from "../ActionsDropdown";
import styled from "styled-components";
import {
  useTable,
  useFilters,
  useGlobalFilter,
  useSortBy,
  usePagination,
} from "react-table";
import { createPortal } from "react-dom";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

const TableContainer = styled.div`
  padding: 20px;
  overflow-x: auto;
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ddd;

  // Apply striped rows styling
  tr:nth-child(odd) {
    background-color: #f2f2f2; /* Light gray for even rows */
  }

  tr:nth-child(even) {
    background-color: #ffffff; /* White for odd rows */
  }
`;

const Th = styled.th`
  padding: 10px;
  background-color: #fff;
  text-align: left;
  cursor: pointer;
  position: relative;
`;

const Td = styled.td`
  padding: 10px;
  // border: 1px solid #ddd;
`;

function GlobalFilter({ globalFilter, setGlobalFilter }) {
  return (
    <div style={{ marginBottom: "10px" }}>
      <input
        value={globalFilter || ""}
        onChange={(e) => setGlobalFilter(e.target.value)}
        placeholder="Search all columns..."
        style={{
          padding: "5px",
          border: "1px solid #ddd",
          borderRadius: "4px",
          width: "100%",
        }}
      />
    </div>
  );
}
// Default Column Filter (Icon-based)
const DefaultColumnFilter = ({
  column: { filterValue, setFilter, preFilteredRows, id },
}) => {
  const [isActive, setIsActive] = useState(false);
  const options = useMemo(() => {
    const uniqueValues = Array.from(
      new Set(preFilteredRows.map((row) => row.values[id]))
    ).map((value) => ({ label: value, value }));
    return [{ label: "All", value: "" }, ...uniqueValues];
  }, [id, preFilteredRows]);

  // Handle icon click
  const handleIconClick = () => {
    setIsActive(!isActive);
  };

  const handleMultiSelectChange = (selectedOptions) => {
    const values = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setFilter(values.length > 0 ? values : undefined);
  };

  return (
    <div style={{ alignItems: "center" }}>
      <div>
        <i
          className="fa-solid fa-ellipsis-vertical"
          onClick={handleIconClick}
          style={{
            cursor: "pointer",
            fontSize: "20px",
            color: "#AC0000",
          }}
        ></i>
      </div>
      <div>
        {isActive &&
          createPortal(
            <div
              style={{
                position: "fixed",
                zIndex: 9999,
                left: "50%",
                top: "50%",
                width: "30%",
                transform: "translate(-50%, -50%)",
              }}
            >
              <div
                style={{
                  position: "relative",
                  background: "white",
                  padding: "20px",
                  borderRadius: "8px",
                  boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
                  backgroundColor: "#A70000",
                }}
              >
                <Select
                  options={options}
                  isMulti
                  value={options.filter((option) =>
                    filterValue?.includes(option.value)
                  )}
                  onChange={handleMultiSelectChange}
                  isClearable
                  isSearchable
                  placeholder={`Filter ${id}`}
                  styles={{
                    menu: (provided) => ({
                      ...provided,
                      zIndex: 9999,
                    }),
                  }}
                />
                <button
                  style={{
                    marginTop: "10px",
                    marginLeft: "150px",
                    padding: "5px 10px",
                    background: "#007bff",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  onClick={() => setIsActive(false)} // Close the popup
                >
                  Close
                </button>
              </div>
            </div>,
            document.body
          )}
      </div>
    </div>
  );
};

function User() {
  const [responseData, setResponseData] = useState([]);
  const [responseDatas, setResponseDatas] = useState([]);
  const [getrole, setrole] = useState([]);
  const [brachdata, setbrachdata] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isUpdateshowModal, setUpdateShowModal] = useState(false);
  const [ispreviewshowModal, setpreviewShowModal] = useState(false);
  const [datatransfer, setdatatransfer] = useState(false);
  const [selectedRole, setSelectedRole] = useState("");
  const [showModals, setShowModals] = useState(false);
  const [showModalspassword, setShowModalspassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const [addData, setAddData] = useState({
    branch_id: "",
    username: "",
    email: "",
    mobile: "",
    designation: "",
    password: "",
    status: "",
    role: "",
    emp_name: "",
  });

  const [updateData, setUpdateData] = useState({
    branch_id: "",
    username: "",
    email: "",
    mobile: "",
    designation: "",
    password: "",
    status: "",
    role: "",
    interal_transefer: "",
  });

  const [checkboxdata, setcheckboxdata] = useState("staff");
  const [empdata, setempdata] = useState([]);

  useEffect(() => {
    gettoken();
    fetchData();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get(apiUrl + "/user", {
        params: { data: localStorage.getItem("branch_id") },
      });
      console.log("Response from server:empid_detail", response);
      if (response && response.status === 200) {
        setTimeout(() => {
          setLoading(false);
        }, 300);
      }
      setResponseData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  useEffect(() => {
    fetchDatas();
    fetchDatased();
  }, []);

  const fetchDatas = async () => {
    try {
      const response = await axios.get(apiUrl + "/Branch");
      console.log("Response from server:", response.data);
      setResponseDatas(response.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const fetchDatased = async () => {
    try {
      const response = await axios.get(apiUrl + "/role_2", {
        params: { data: localStorage.getItem("branch_id") },
      });
      console.log("Response from server :", response.data);
      setrole(response.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const [role_id, setroleid] = useState("");
  const [previllages, setprevillages] = useState({});

  const gettoken = async () => {
    const token = localStorage.getItem("token");
    // console.log("the toekn in the localStorage is : ",token);
    try {
      const response = await axios.post(apiUrl + "/get_detail", {
        token: token,
      });
      console.log("token detail from server:", response.data);
      // setResponseData(response.data);

      console.log("The role id is : ", response.data.detail.rolename);
      setroleid(response.data.detail.rolename);
      console.log("the role_id is : ", role_id);

      localStorage.setItem("role_id", response.data.detail.rolename);

      const id = response.data.detail.rolename;

      // getpages();

      if (id) {
        try {
          const response = await axios.get(apiUrl + `/role_2/${id}`);

          console.log("the reponse list in brach is : ", response.data.modules);

          const modules = response.data.modules;

          const filtered_access = modules.filter(
            (item) => item.name == "Users"
          );

          console.log("the modules is : ", filtered_access[0].actions);

          setprevillages(filtered_access[0].actions);

          console.log("the assigned previllages is : ", previllages.add);
        } catch (error) {
          console.error("Error fetching data:", error.message);
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  // const handleNewButtonClick = () => {
  //   if (previllages?.add === true ) {
  //     setShowModal(true);
  // }
  // else if(previllages?.all === true){
  //     setShowModal(true);
  // }
  //   else {
  //       toast.error("You don't have the permission");
  //   }

  // };

  const handlesubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      console.log("addd data", addData);

      const formData = {
        branch_id: addData.branch_id,
        username: addData.username,
        email: addData.email,
        mobile: addData.mobile,
        password: addData.password,
        status: addData.status,
        role: addData.role,
        emp_name: addData.emp_name,
        designation: addData.designation,
      };

      console.log("the addData is : ", addData);
      console.log("the form data is : ", formData);
      const response = await axios.post(apiUrl + "/user", formData);
      console.log("Updated:", response);
      setShowModal(false);
      toast.success("User added successfully!");
      setAddData({
        branch_id: "",
        username: "",
        email: "",
        mobile: "",
        designation: "",
        password: "",
        status: "",
        role: "",
        emp_name: "",
      });
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      fetchData();
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };

  const [isPasswordChanged, setIsPasswordChanged] = useState(false);

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setUpdateData({ ...updateData, password: newPassword });
    console.log(":this is my length console", newPassword.length > 0);
    // Set `isPasswordChanged` to true when there's any change in the password field
    setIsPasswordChanged(newPassword.length > 0); // true if there's any value, false if empty
  };

  const [updateid, setUpdateId] = useState("");

  const [designationnew, setdesignationnew] = useState("");

  const [empdetail, setempdetail] = useState("");

  const handleUpdate = (_id, data) => {
    setUpdateId(_id);
    console.log(" the data to update", data);

    console.log(" the data to update empid_detail", data.empid_detail);

    setempdetail(data.empid_detail);
    // Log to verify the designation value
    console.log(
      " the data to update designation",
      data.designation?.designation
    );

    // Set designationnew state to the fetched designation's _id
    setdesignationnew(data.designation?.designation || "");

    // Update other form data
    setUpdateData({
      // branch_id: data.branch_id,
      // username: data.username,
      // email: data.email,
      // mobile: data.mobile,
      // designation: data.designation?._id || "", // Use _id for matching in the dropdown
      // password: data.password,
      // status: data.status,
      // role: data.role,

      branch_id: data.branch_id,
      username: data.username,
      email: data.email,
      mobile: data.mobile,

      designation: data.designation_id,
      password: data.password,
      status: data.status,
      role: data.role,
      role_detail: data._id,
      role_detail: data.rolename,
      interal_transefer: data.interal_transefer,
    });

    setUpdateShowModal(true); // Show the update modal
  };

  const handlepreview = (_id, data) => {
    setUpdateId(_id);
    console.log(" the data to update", data);

    console.log(" the data to update empid_detail", data.empid_detail);

    setempdetail(data.empid_detail);
    // Log to verify the designation value
    console.log(
      " the data to update designation",
      data.designation?.designation
    );

    // Set designationnew state to the fetched designation's _id
    setdesignationnew(data.designation?.designation || "");

    setpreviewShowModal(true); // Show the update modal
    // Update other form data
    setUpdateData({
      branch_id: data.branch_id,
      username: data.username,
      email: data.email,
      mobile: data.mobile,
      designation: data.designation_id, // Use _id for matching in the dropdown
      password: data.password,
      status: data.status,
      role: data.role,
      last_logout_time: data.last_logout_time,
      interal_transefer: data.interal_transefer,
    });
  };

  const handleupdatesubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const formData = {
        branch_id: updateData.branch_id,
        username: updateData.username,
        email: updateData.email,
        mobile: updateData.mobile,
        designation: updateData.designation,
        password: updateData.password,
        status: updateData.status,
        role: updateData.role,
        interal_transefer: updateData.interal_transefer,
      };
      if (isPasswordChanged) {
        console.log("this is true called ");
        console.log("this is isPasswordChanged", isPasswordChanged);
        console.log("the update submit data", formData);
        const response = await axios.put(
          apiUrl + `/password/${updateid}`,
          formData
        );
        console.log("response for update", response);
        setUpdateShowModal(false);
        toast.success("Update successfully!");
        fetchData();
        setIsPasswordChanged(false);
      } else {
        console.log("this is false called ");
        console.log("this is isPasswordChanged", isPasswordChanged);
        console.log("formData.designation", formData.designation);
        const response = await axios.put(
          apiUrl + `/user/${updateid}`,
          formData
        );
        console.log("response for update", response);
        setUpdateShowModal(false);
        toast.success("Update successfully!");
        setTimeout(() => {
          setLoading(false);
        }, 1000);
        fetchData();
      }
    } catch (error) {
      console.error("Error updating data:", error.message);
    }
  };

  const handleCloseModal = () => {
    setShowModals(false);
  };

  const handleCloseModalpassword = () => {
    setShowModalspassword(false);
  };

  const [getdeleteid, setdeleteid] = useState("");
  const [getdeletename, setdeletename] = useState("");
  const handleOpenModal = (_id, username) => {
    console.log(" the id", _id);
    console.log(" the name", username);
    setdeleteid(_id);
    setdeletename(username);
    setShowModals(true);
  };

  const passwordsubmit = (_id, rolename) => {
    setdeleteid(_id);
    setdeletename(rolename);
    setShowModalspassword(true);
  };
  const handleDelete = async () => {
    try {
      setLoading(true);
      await axios.delete(apiUrl + `/user/${getdeleteid}`);
      toast.error("Deleted successfully!");
      setShowModals(false);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
      fetchData();
    } catch (error) {
      console.error("Error deleting role:", error.message);
    }
  };

  // the pagination ---------------------------------------------------------------------
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = responseData.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const filtered = currentItems.filter((item) =>
    Object.values(item).some(
      (value) =>
        (typeof value === "string" &&
          value.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (typeof value === "number" && value.toString().includes(searchQuery))
    )
  );

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  const totalPages = Math.ceil(responseData.length / itemsPerPage);

  const goToNextPage = () => {
    setCurrentPage((prevPage) =>
      prevPage === totalPages ? prevPage : prevPage + 1
    );
  };

  const goToPrevPage = () => {
    setCurrentPage((prevPage) => (prevPage === 1 ? prevPage : prevPage - 1));
  };
  // the pagination  end ---------------------------------------------------------------------

  const createPagination = () => {
    let liTag = [];
    let totalPages = pageCount; // Total pages
    let currentPage = state.pageIndex;
    let active;

    // Previous Page Button
    liTag.push(
      <li
        className={`page-item ${!canPreviousPage ? "disabled" : ""}`}
        key="prev"
      >
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage - 1)}
          disabled={!canPreviousPage}
        >
          <FaAngleLeft /> Prev
        </button>
      </li>
    );

    // Always show first page
    if (totalPages > 1) {
      liTag.push(
        <li
          className={`page-item ${currentPage === 0 ? "active" : ""}`}
          key={0}
        >
          <button className="page-link" onClick={() => gotoPage(0)}>
            1
          </button>
        </li>
      );
    }

    // Show second page if total pages > 2
    if (totalPages > 2) {
      liTag.push(
        <li
          className={`page-item ${currentPage === 1 ? "active" : ""}`}
          key={1}
        >
          <button className="page-link" onClick={() => gotoPage(1)}>
            2
          </button>
        </li>
      );
    }

    // Add "..." before current page group
    if (currentPage > 3) {
      liTag.push(
        <li className="page-item disabled" key="dot-prev">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Show 3 pages around current page
    for (
      let i = Math.max(2, currentPage - 1);
      i <= Math.min(totalPages - 3, currentPage + 1);
      i++
    ) {
      active = currentPage === i ? "active" : "";
      liTag.push(
        <li className={`page-item ${active}`} key={i}>
          <button className="page-link" onClick={() => gotoPage(i)}>
            {i + 1}
          </button>
        </li>
      );
    }

    // Add "..." after current page group
    if (currentPage < totalPages - 4) {
      liTag.push(
        <li className="page-item disabled" key="dot-next">
          <span className="page-link">...</span>
        </li>
      );
    }

    // Always show last two pages if totalPages > 2
    if (totalPages > 2) {
      liTag.push(
        <li
          className={`page-item ${currentPage === totalPages - 2 ? "active" : ""
            }`}
          key={totalPages - 2}
        >
          <button
            className="page-link"
            onClick={() => gotoPage(totalPages - 2)}
          >
            {totalPages - 1}
          </button>
        </li>
      );
    }

    if (totalPages > 1) {
      liTag.push(
        <li
          className={`page-item ${currentPage === totalPages - 1 ? "active" : ""
            }`}
          key={totalPages - 1}
        >
          <button
            className="page-link"
            onClick={() => gotoPage(totalPages - 1)}
          >
            {totalPages}
          </button>
        </li>
      );
    }

    // Next Page Button
    liTag.push(
      <li className={`page-item ${!canNextPage ? "disabled" : ""}`} key="next">
        <button
          className="page-link"
          onClick={() => gotoPage(currentPage + 1)}
          disabled={!canNextPage}
        >
          Next <FaAngleRight />
        </button>
      </li>
    );

    return liTag;
  };

  // //////////////////////////////
  const handleAdditionalChange = async (e) => {
    const selectedBranchId = e.target.value; // Get the selected value from the dropdown
    console.log(
      "Additional change function called with value:",
      selectedBranchId
    );
    try {
      const response = await axios.get(
        apiUrl + `/staff_based_on_branch/${selectedBranchId}`
      );
      console.log("Response from server selectedBranchId:", response.data);
      setempdata(response.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const handleAdditionalChanges = async (e) => {
    const selectedBranchIded = e.target.value; // Get the selected value from the dropdown
    console.log(
      "Additional change function called with value:",
      selectedBranchIded
    );
    try {
      const response = await axios.put(
        apiUrl + `/staff_based_on_branch/${selectedBranchIded}`
      );
      console.log("Response from server selectedBranchId:", response.data);
      setempdata(response.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };
  useEffect(() => {
    staffdatas();
    desigantiondata();
  }, []);
  const [staff, setstaff] = useState([]);
  const [designation, setDesignation] = useState([]);

  async function staffdatas() {
    const responsed = await axios.get(apiUrl + `/staff`);
    console.log("responsed", responsed);
    setstaff(responsed.data);
  }

  async function desigantiondata() {
    const responsed = await axios.get(apiUrl + `/designation`);
    console.log("responsed", responsed);
    setDesignation(responsed.data);
  }

  const handleChange = async (e) => {
    const selectemp = e.target.value;

    console.log("thw selectemp ", selectemp);

    try {
      const response = await axios.get(apiUrl + `/staff/${selectemp}`);

      const empdatased = response.data;
      setempdata(response.data);

      console.log(" the setadddata is after ", empdatased);

      setAddData((prevState) => ({
        ...prevState,
        // username: `${empdatased[0]?.empid} - ${empdatased[0]?.name}`,
        username: empdatased[0]?.empid || "",
        email: empdatased[0]?.email || "",
        mobile: empdatased[0]?.mobile || "",
        emp_name: empdatased[0]?.name || "",
        // designation: [
        //   empdatased[0]?.designation[0]?.designation || "",
        //   empdatased[0]?.designation[0]?._id || "",
        // ],

        designation: empdatased[0]?.designation[0]?._id || "",
      }));
      console.log(addData);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  // const handleChange = async (e) => {
  //   const selectedEmpId = e.target.value;

  //   console.log("Selected Employee ID:", selectedEmpId);

  //   if (!selectedEmpId) return; // Early exit if no employee is selected

  //   try {
  //     const response = await axios.get(`${apiUrl}/staff/${selectedEmpId}`);
  //     const empData = response.data;

  //     console.log("Fetched Employee Data:", empData);

  //     // Update state with the fetched employee data
  //     setAddData((prevState) => ({
  //       ...prevState,
  //       username: `${empData.empid} - ${empData.name}`,
  //       email: empData.email || "",
  //       mobile: empData.mobile || "",
  //       designation: [
  //         empData.designation[0]?.designation || "",
  //         empData.designation[0]?._id || "",
  //       ],
  //     }));

  //     // Optionally log the updated addData state
  //     console.log("Updated addData state:", {
  //       ...addData,
  //       username: `${empData.empid} - ${empData.name}`,
  //       email: empData.email || "",
  //       mobile: empData.mobile || "",
  //       designation: [
  //         empData.designation[0]?.designation || "",
  //         empData.designation[0]?._id || "",
  //       ],
  //     });
  //   } catch (error) {
  //     console.error("Error fetching employee data:", error.message);
  //   }
  // };

  const handleChangedd = async (e) => {
    const selectemp = e.target.value;
    console.log("thw selectemp ", selectemp);

    try {
      const response = await axios.put(apiUrl + `/staff/${selectemp}`);
      const empdatased = response.data;
      setempdata(response.data);
      console.log(" the setadddata is after ", empdatased);
      setUpdateData((prevState) => ({
        ...prevState,
        username: `${empdatased[0]?.empid} - ${empdatased[0]?.name}`,
        email: empdatased[0]?.email || "",
        mobile: empdatased[0]?.mobile || "",
        designation: [
          // empdatased[0]?.designation[0]?.designation || "",
          empdatased[0]?.designation[0]?._id || "",
        ],
      }));
      console.log(addData);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const [isStaffChecked, setIsStaffChecked] = useState(true);
  const [isManagementChecked, setIsManagementChecked] = useState(false);

  // const handleStaffCheckboxChange = (e) => {
  //   setIsStaffChecked(e.target.checked);
  //   setIsManagementChecked(false); // Uncheck management if staff is checked

  //   setAddData((prevState) => ({
  //     ...prevState,

  //     branch_id: "",
  //     username: "",
  //     email: "",
  //     mobile: "",
  //     designation: "",
  //     password: "",
  //     status: "",
  //     role: "",
  //   }));
  // };

  const handleStaffCheckboxChange = (e) => {
    // Toggle the staff checkbox and reset the management checkbox
    setIsStaffChecked(e.target.checked);
    setIsManagementChecked(false); // Uncheck management if staff is checked
    // setShowDesignation(e.target.checked);
    setShowBranch(e.target.checked);
    // Reset addData
    setAddData((prevState) => ({
      ...prevState,
      branch_id: "",
      username: "",
      email: "",
      mobile: "",
      designation: "",
      password: "",
      status: "",
      role: "",
      emp_name: "",
    }));
  };

  // const handleManagementCheckboxChange = (e) => {
  //   setShowDesignation(!e.target.checked);
  //   setIsManagementChecked(e.target.checked);
  //   setIsStaffChecked(false); // Uncheck staff if management is checked
  //   console.log(empdata, "empdata llllll--90");
  //   setAddData((prevState) => ({
  //     ...prevState,

  //     branch_id: "",
  //     username: "",
  //     email: "",
  //     mobile: "",
  //     designation: "",
  //     password: "",
  //     status: "",
  //     role: "",
  //   }));
  // };
  const handleManagementCheckboxChange = (e) => {
    // Toggle the management checkbox and reset the staff checkbox
    setIsManagementChecked(e.target.checked);
    setIsStaffChecked(false); // Uncheck staff if management is checked
    // setShowDesignation(!e.target.checked);
    setShowBranch(!e.target.checked);
    // Reset addData
    setAddData((prevState) => ({
      ...prevState,
      branch_id: "",
      username: "",
      email: "",
      mobile: "",
      designation: "",
      password: "",
      status: "",
      role: "",
      emp_name: "",
    }));
  };

  // const [showDesignation, setShowDesignation] = useState(true);
  const [showBranch, setShowBranch] = useState(true);

  const [isModalOpened, setIsModalOpened] = useState(false);
  const [loginstatus, setloginstatus] = useState("");
  const [modalData, setModalData] = useState({
    username: "",
    login_status: "",
  });

  const [gettruechange, settruechange] = useState("");

  const handleOpenModaled = (id, item, login_status) => {
    settruechange(id);
    setloginstatus(login_status);
    setModalData({
      username: item.username, // Assume the username is in item.username
      login_status: item.login_status, // Assume logicStatus is in item.logicStatus
    });
    setIsModalOpened(true);
    console.log(" ythis", gettruechange);
  };

  // ======================login status==========code ============
  const handleUpdateloginstatus = async (e) => {
    e.preventDefault();

    try {
      const formData = {
        login_status: loginstatus, // Update based on the selected loginstatus
      };

      console.log("Submitting update data:", formData);

      // Make PUT request to update the login status
      const response = await axios.put(
        `${apiUrl}/login/${gettruechange}`,
        formData
      );

      console.log("Update response:", response.data);

      // Close modal and show success message
      setIsModalOpened(false);
      toast.success("Login status updated successfully!");

      // Refresh data to reflect updates
      fetchData();
    } catch (error) {
      console.error("Error updating login status:", error.message);
      toast.error("Failed to update login status. Please try again.");
    }
  };

  // ======================login status==========code ============
  const login_status = async () => {
    try {
      console.log("Fetching login status for", gettruechange);
      const response = await axios.get(
        `${apiUrl}/login_status/${gettruechange}`
      );
      console.log("Response for login_status:", response);

      // Access and set the login_status
      setloginstatus(response.data?.login_status || ""); // Fallback to empty if undefined
      console.log("Updated loginstatus state:", response.data?.login_status);
      settruechange({
        ...gettruechange, // Retain other properties
        gettruechange: "", // Update the specific property
      });
    } catch (error) {
      console.error("Error fetching login status:", error.message);
    }
  };

  const handleCloseModallogin = () => {
    setIsModalOpened(false);
  };

  const handleCloseModaled = () => {
    setIsModalOpened(false);
  };

  const handleUpdated = () => {
    // Perform update logic here
    console.log("Update clicked", modalData);
    handleCloseModal();
  };

  const formatTime = (timeStr) => {
    if (!timeStr) return ""; // Handle cases where time is missing
    let [hours, minutes, seconds] = timeStr.split(":").map(Number);
    let ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; // Convert 0 to 12
    return `${hours}:${minutes}:${seconds} ${ampm}`;
  };

  const [rolename, setrolename] = useState([]);
  useEffect(() => {
    const branchName = localStorage.getItem("branch_name");
    setrolename(branchName);
  }, []);

  const data = useMemo(() => {
    return responseData.map((item) => ({
      _id: item._id,
      branch: item.branch_id[0]?.branch_name,
      branch_id: item.branch_id[0]?._id,
      username: item.username,
      emp_name: item.emp_name,
      email: item.email,
      mobile: item.mobile,
      status: item.status,
      login_status: item.login_status,
      password: item.password,
      designation_id: item.designation[0]?._id,
      designation: item.designation[0]?.designation,
      role: item.role,
      interal_transefer: item.interal_transefer,
      role_detail: item.role_detail[0]?._id,
      role_name: item.role_detail[0]?.rolename,
      last_logout_time: item.last_logout_time
        ? new Date(item.last_logout_time).toLocaleString("en-US")
        : null, // Ensure null safety
    }));
  }, [responseData]);

  const columns = useMemo(
    () => [
      {
        Header: "S.No",
        id: "serialNo",
        Cell: ({ row }) => {
          return row.index + 1;
        },
      },
      {
        Header: "Branch",
        accessor: "branch",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
        Cell: ({ value }) => (value ? value : "Branches"),
      },

      {
        Header: "Username",
        accessor: "username",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },

      {
        Header: "Staff Name",
        accessor: "emp_name",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
        Cell: ({ value }) => (value ? value : "Admin"),
      },

      {
        Header: "Mobile",
        accessor: "mobile",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },

      {
        Header: "Role",
        accessor: "role_name",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
      },
      {
        Header: "Status",
        accessor: "status",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
        Cell: ({ value }) => {
          // Conditional logic for the status
          if (value === "Active") {
            return (
              <td className="text-center hideres">
                <p className="text-white green-label">{value}</p>
              </td>
            );
          } else {
            return (
              <td className="text-center hideres">
                <p className="text-white red-label">{value}</p>
              </td>
            );
          }
        },
      },
      {
        Header: "Login",
        accessor: "login_status",
        Filter: DefaultColumnFilter,
        filter: "multiSelectFilter",
        Cell: ({ value }) => {
          const statusText = value === "true" ? "Online" : "Offline";
          const statusClass = value === "true" ? "green-label" : "yellow-label";

          return (
            <td className="text-center hideres">
              <p className={`text-white ${statusClass}`}>{statusText}</p>
            </td>
          );
        },
      },
    ],
    []
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state,
    setGlobalFilter,
    setPageSize,
    page,
    canPreviousPage,
    canNextPage,
    pageCount,
    gotoPage,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageSize: 10 },
      defaultColumn: { Filter: DefaultColumnFilter },
      filterTypes: {
        multiSelectFilter: (rows, columnIds, filterValue) => {
          if (!filterValue || filterValue.length === 0) {
            return rows;
          }
          return rows.filter((row) => {
            const rowValue = row.values[columnIds[0]];
            const rowValueStr = String(rowValue);
            return filterValue.some((filterVal) =>
              rowValueStr.includes(String(filterVal))
            );
          });
        },
      },
    },
    useFilters,
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  // thiis is data transefer code

  return (
    <>
      {loading === true ? (
        <div className="loading-overlay">
          <div className="loading-message">
            <img
              className="loadinggif"
              src={require("../../assets/img/output-onlinegiftools.gif")}
            />{" "}
          </div>
        </div>
      ) : (
        <div className="d-none"></div>
      )}

      <div className="top">
        <div className="" style={{ marginTop: "-80px" }}>
          <div className="row mb-3">
            <div className="col-lg-11">
              <Link to="/dashboard" className="text-secondary dashBoard_text">
                <b>Dashboard / </b>
              </Link>
              <Link to="" className="text-danger dashBoard_text">
                <b>User</b>
              </Link>
            </div>
          </div>
        </div>

        {/* ------------ search and per page ----------------------------*/}

        {/* <div className="mb-3 mt-3">
          <div className="row">
            <div className="col-lg-2 col-md-4 col-sm-4 d-flex">
              <label className="form-label text-dark mt-2">Show : </label>
              <div>
                <select
                  className="form-control w-100 mx-2"
                  onChange={(e) => {
                    setItemsPerPage(e.target.value);
                  }}
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                </select>
              </div>
            </div>
            <div className="col-lg-7 col-md-4 col-sm-1"></div>
            <div className="col-lg-3 col-md-4 col-sm-7">
              <div className="w-full flex-1">
                <form>
                  <div className="relative">
                    <input
                      className="form-control w-full bg-white  appearance-none pl-8  dark:bg-gray-950"
                      placeholder="Search ..."
                      type="search"
                      value={searchQuery}
                      onChange={handleSearchChange}
                    />
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div> */}

        <div className="mb-1 mt-3">
          <div className="row">
            <div className="col-lg-7 col-md-4 col-sm-1">
              <div className=" col-lg-9 d-flex">
                <h5 className="mt-1">User Details</h5>
                <div className="mx-3">
                  {previllages.add && (
                    <button
                      className="btn btn-success add mx-3"
                      onClick={() => setShowModal(true)}
                    >
                      Add
                    </button>
                  )}

                  {/* <button className="btn  add " onClick={handleNewButtonClick}>
              Add
            </button> */}
                </div>
              </div>
            </div>
            <div className="col-lg-5 col-md-4 col-sm-7 d-flex justify-content-end">
              <div className="w-full flex-1 me-5">
                <form>
                  <div className="relative">
                    <input
                      className="form-control w-full bg-white appearance-none pl-8 dark:bg-gray-950"
                      placeholder="Search ..."
                      type="search"
                      value={state.globalFilter || ""} // Use the globalFilter value
                      onChange={(e) => setGlobalFilter(e.target.value)} // Update global filter
                    />
                  </div>
                </form>
              </div>
              {/* </div>
             <div className="col-lg-2 col-md-4 col-sm-4 d-flex"> */}
              <div className="d-flex me-2">
                <label className="form-label text-dark mt-1">Show :</label>
                <div>
                  <select
                    className="form-control w-100 mx-2"
                    value={state.pageSize}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === "All") {
                        setPageSize(data.length); // 'data' should be your dataset containing all the entries
                      } else {
                        setPageSize(Number(value));
                      }
                    }}
                  >
                    <option value="All">All</option> {/* Add 'All' option */}
                    {[10, 20, 100, 200, 500, 1000].map((pageSize) => (
                      <option key={pageSize} value={pageSize}>
                        {pageSize}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* --------------------------------end------------------------------------------- */}
        <Table {...getTableProps()}>
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <Th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                  >
                    <div className="d-flex">
                      <div className="mx-2">{column.render("Header")}</div>
                      <div>
                        {column.canFilter ? column.render("Filter") : null}
                      </div>
                      <div className="mx-1">
                        {column.isSorted
                          ? column.isSortedDesc
                            ? " 🔽"
                            : " 🔼"
                          : ""}
                      </div>
                    </div>
                  </Th>
                ))}
                <Th className="text-center">Action</Th>
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <Td {...cell.getCellProps()}>{cell.render("Cell")}</Td>
                  ))}
                  <Td className="text-center">
                    <ActionsDropdown
                      row={row.original}
                      permissions={{
                        edit: previllages.edit,
                        delete: previllages.delete,
                      }}
                      onEdit={(id, row) =>
                        handleUpdate(id, row)
                      }
                      onDelete={(id, row) =>
                        handleOpenModal(id, row.username)
                      }
                      onInfo={(id, row) =>
                        handlepreview(id, row)
                      }
                      onLock={(id, row) =>
                        handleOpenModaled(id, row)
                      }
                    />
                  </Td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        {/* Table */}
        {/* <div className="card">
          <div className="mt-2">
            <table className="table table-striped responsive">
              <thead>
                <tr>
                  <th>S.No</th>
                  {rolename === "Branches" && <th>Branch</th>}
                  <th>User Name</th>
                  <th>Staff Name</th>
                  <th>Mobile No</th>
                  <th>Role</th>
                  <th>Status</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1} </td>
                    {rolename === "Branches" && (
                      <td>{item.branch_id[0]?.branch_name}</td>
                    )}




                    <td>{item.username}</td>
                    <td>{item.emp_name ? item.emp_name : "-"}</td>
                    <td>{item.mobile}</td>
                    <td>{item.role_detail[0]?.rolename}</td>
                    {item.status == "Active" ? (
                      <td className="text-center hideres ">
                        <p className=" text-white green-label">{item.status}</p>
                      </td>
                    ) : (
                      <td className="text-center hideres">
                        <p className="text-white red-label">{item.status}</p>
                      </td>
                    )}


                    <td className="text-center">
                      {item.role_detail[0]?.rolename !== "superadmin" &&
                        previllages.edit && (
                          <button
                            className="btn updelete mx-2"
                            onClick={() => handleUpdate(item._id, item)}
                          >
                            <i className="fa-solid fa-pen-to-square"></i>
                          </button>
                        )}


                      {item.role_detail[0]?.rolename !== "superadmin" &&
                        previllages.delete && (
                          <button
                            className="btn delete"
                            onClick={() =>
                              handleOpenModal(item._id, item.username)
                            }
                          >
                            <i className="fa-solid fa-trash-can"></i>
                          </button>
                        )}

                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div> */}

        {/* Modal for adding a new user */}
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          className="custom-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title id="modeti">Add New User</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row   ">
              <div className="col-lg-6">
                <div className="row mb-3">
                  <div className="col-lg-6">
                    <td className="management">
                      <input
                        type="checkbox"
                        checked={isManagementChecked}
                        onChange={handleManagementCheckboxChange}
                      />
                    </td>
                    <th className="px-1">Management</th>
                  </div>
                  <div className="col-lg-5">
                    <td className="staff">
                      <input
                        type="checkbox"
                        checked={isStaffChecked}
                        onChange={handleStaffCheckboxChange}
                      />
                    </td>
                    <th className="px-1">Staff</th>
                  </div>
                </div>
                <div className="form-group">
                  <div className="floating-label">
                    <label className="form-label">
                      <b></b>
                    </label>
                    {showBranch && (
                      <select
                        className="form-select"
                        value={addData.branch_id}
                        onChange={(e) => {
                          setAddData({ ...addData, branch_id: e.target.value });
                          handleAdditionalChange(e); // Call the additional function here
                        }}
                        required
                      >
                        <option value="">Select Branch</option>
                        {responseDatas.map((item, index) => (
                          <option key={index} value={item._id}>
                            {item.branch_name}
                          </option>
                        ))}
                      </select>
                    )}
                    <label
                      className={addData.branch_id ? "filled" : ""}
                    ></label>
                  </div>

                  <div className="floating-label">
                    {isManagementChecked ? (
                      <input
                        className="form-control"
                        type="email"
                        placeholder="User Name"
                        value={addData.username}
                        onChange={(e) =>
                          setAddData({ ...addData, username: e.target.value })
                        }
                        required
                      />
                    ) : (
                      <select
                        className="form-select"
                        value={addData.username}
                        onChange={handleChange}
                        required
                      >
                        <option value="" disabled>
                          Select Emp
                        </option>
                        {empdata.map((item, index) => (
                          <option key={index} value={item._id}>
                            {item.empid} - {item.name}
                          </option>
                        ))}
                      </select>
                    )}
                    <label className={addData.username ? "filled" : ""}>
                      User Name
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="email"
                      placeholder=""
                      value={addData.email}
                      onChange={(e) =>
                        setAddData({ ...addData, email: e.target.value })
                      }
                      required
                    />
                    <label className={addData.email ? "filled" : ""}>
                      Email
                    </label>
                  </div>

                  {/* {console.log("the mobile number", addData.mobile)}
                  {console.log("the mobile email", addData.email)}
                  {console.log("the mobile password", addData.password)} */}
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="tel"
                      placeholder=""
                      value={addData.mobile}
                      onChange={(e) =>
                        setAddData({ ...addData, mobile: e.target.value })
                      }
                      required
                    />
                    <label className={addData.mobile ? "filled" : ""}>
                      Mobile No
                    </label>
                  </div>
                </div>
              </div>
              {/* {console.log(staff, "llllll--90")} */}
              <div className="col-lg-6 ">
                <div className="form-group">
                  {/* <div className="floating-label">
                  <select
                    className="form-control"
                    value={addData.designation}
                    onChange={(e) =>
                      setAddData({ ...addData, designation: e.target.value })
                    }
                    required
                  >
                    <option value="" disabled>
                      Select Designation
                    </option>
                    {designation.map((item, index) => (
                      <option key={index} value={item._id}>
                        {item.designation}
                      </option>
                    ))}
                  </select>

                  <label className={addData.designation ? "filled" : ""}>
                    {addData.designation
                      ? "Selected Designation"
                      : "Select Designation"}
                  </label>
                </div> */}

                  <div className="floating-label">
                    {/* {showDesignation && ( */}
                    <select
                      className="form-control"
                      value={addData.designation}
                      onChange={(e) =>
                        setAddData({ ...addData, designation: e.target.value })
                      }
                      required
                    >
                      <option value="" disabled>
                        Select Designation
                      </option>
                      {designation.map((item) => (
                        <option key={item._id} value={item._id}>
                          {item.designation}
                        </option>
                      ))}
                    </select>
                    {/* )} */}

                    <label className={addData.designation ? "filled" : ""}>
                      {addData.designation
                        ? "Selected Designation"
                        : "Select Designation"}
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="password"
                      placeholder=""
                      value={addData.password}
                      onChange={(e) =>
                        setAddData({ ...addData, password: e.target.value })
                      }
                      required
                    />
                    <label className={addData.password ? "filled" : ""}>
                      Password
                    </label>
                  </div>

                  <div className="floating-label">
                    <select
                      className="form-select"
                      value={addData.role}
                      onChange={(e) => {
                        setAddData({ ...addData, role: e.target.value });
                      }}
                      required
                    >
                      <option value="">Select Role </option>
                      {getrole.map((item, index) => (
                        <option key={index} value={item._id}>
                          {item.rolename}
                        </option>
                      ))}
                    </select>
                    <label className={addData.role ? "filled" : ""}></label>
                  </div>

                  <div className="floating-label">
                    <select
                      className="form-control"
                      placeholder=""
                      value={addData.status}
                      onChange={(e) =>
                        setAddData({ ...addData, status: e.target.value })
                      }
                    >
                      <option value="">Select Status</option>
                      <option value="Active">Active</option>
                      <option value="InActive">InActive</option>
                    </select>
                    <label className={addData.status ? "filled" : ""}></label>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={() => setShowModal(false)}
            >
              Cancel
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={handlesubmit}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>
        {/* ----------------update */}

        {/* /////////////////////////////////////////////////////// */}
        <div className="custom-modal-container">
          <Modal
            show={isModalOpened}
            onHide={handleCloseModallogin} // Correctly closes the modal
            className="custom-modal" // Apply a custom class
          >
            <Modal.Header closeButton>
              <Modal.Title id="modeti">Login Status</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {/* Username Input Field */}
              <div className="row">
                <div className="col-lg-6">
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      value={modalData.username || ""}
                      onChange={(e) =>
                        setUpdateData({
                          ...modalData,
                          username: e.target.value,
                        })
                      }
                      required
                      disabled
                    />
                    <label className={modalData.username ? "filled" : ""}>
                      User Name
                    </label>
                  </div>
                </div>
                <div className="col-lg-6">
                  {/* Login Status Select */}
                  <div className="floating-label">
                    <select
                      className="form-control"
                      value={loginstatus?.toString() || ""}
                      onChange={(e) =>
                        setloginstatus(e.target.value === "true")
                      }
                      required
                    >
                      <option value="">Login Status</option>
                      <option value="true">Online</option>
                      <option value="false">Offline</option>
                    </select>
                    <label
                      className={loginstatus !== undefined ? "filled" : ""}
                    >
                      Select Status
                    </label>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={handleCloseModallogin}>
                Cancel
              </Button>
              <Button variant="primary" onClick={handleUpdateloginstatus}>
                Update
              </Button>
            </Modal.Footer>
          </Modal>
        </div>

        {/* ///////////////////////////////////////////////////////////////////////// */}

        <Modal
          show={isUpdateshowModal}
          onHide={() => setUpdateShowModal(false)}
          className="custom-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title id="modeti">Update User</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  {empdetail && empdetail.length > 0 && (
                    <div className="floating-label">
                      <label className="form-label">
                        <b></b>
                      </label>
                      <select
                        className="form-select"
                        value={updateData.branch_id}
                        onChange={(e) => {
                          setUpdateData({
                            ...updateData,
                            branch_id: e.target.value,
                          }); // Update the state
                          handleAdditionalChanges(e); // Call the additional function here
                        }}
                        required
                      >
                        {responseDatas.map((item, index) => (
                          <option key={index} value={item.branch_id}>
                            {item.branch_id}
                          </option>
                        ))}
                      </select>
                      <label
                        className={updateData.branch_id ? "filled" : ""}
                      ></label>
                    </div>
                  )}
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      placeholder=""
                      value={updateData.username}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          username: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.username ? "filled" : ""}>
                      User Name
                    </label>
                  </div>

                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="email"
                      placeholder=""
                      value={updateData.email}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, email: e.target.value })
                      }
                      required
                    />
                    <label className={updateData.email ? "filled" : ""}>
                      Email
                    </label>
                  </div>
                  <div className="floating-label">
                    <input
                      className="form-control"
                      placeholder=""
                      type="tel"
                      value={updateData.mobile}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, mobile: e.target.value })
                      }
                      required
                    />
                    <label className={addData.mobile ? "filled" : ""}>
                      Mobile
                    </label>
                  </div>

                  <div className="floating-label">
                    <select
                      className="form-select"
                      value={updateData.interal_transefer}
                      onChange={(e) => {
                        setUpdateData({
                          ...updateData,
                          interal_transefer: e.target.value,
                        });
                      }}
                      required
                    >
                      {/* <option value="">Select Designation</option> */}
                      {staff.map((item) => (
                        <option key={item} value={item.empid}>
                          {item.empid}-{item.name}
                        </option>
                      ))}
                    </select>
                    <label
                      className={updateData.interal_transefer ? "filled" : ""}
                    >
                      Interal Transefer
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  {/* <div className="floating-label">
                                    <input className="form-control" placeholder='' type="text" value={updateData.designation[0]?.designation} onChange={(e) => setUpdateData({ ...updateData, designation: e.target.value })} required />
                                    <label className={updateData.designation ? "filled" : ""}>
                                        Designation
                                    </label>
                                </div> */}
                  {/* 
                <div className="floating-label">
                  <select
                    className="form-select"
                    value={designationnew}
                    onChange={(e) => {
                      setUpdateData({
                        ...updateData,
                        designation: e.target.value,
                      });
                    }}
                    required
                  >
             
                    {designation.map((item, index) => (
                      <option key={item._id} value={item._id}>
                        {item.designation}
                      </option>
                    ))}
                  </select>
                  <label
                    className={updateData.designation ? "filled" : ""}
                  ></label>
                </div> */}

                  <div className="floating-label">
                    <select
                      className="form-select"
                      value={updateData.designation}
                      onChange={(e) => {
                        setUpdateData({
                          ...updateData,
                          designation: e.target.value,
                        });
                      }}
                      required
                    >
                      {/* <option value="">Select Designation</option> */}
                      {designation.map((item) => (
                        <option key={item._id} value={item._id}>
                          {item.designation}
                        </option>
                      ))}
                    </select>
                    {/* <label className={updateData.designation ? "filled" : ""}>Designation</label> */}
                  </div>

                  {/* <div className="floating-label">
                  <input
                    className="form-control"
                    type="password"
                    placeholder=""
                    value={updateData.password}
                    onChange={(e) =>
                      setUpdateData({ ...updateData, password: e.target.value })
                    }
                    required
                  />
                  <label className={updateData.password ? "filled" : ""}>
                    Password12
                  </label>
                </div> */}
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="password"
                      placeholder=""
                      value={updateData.password}
                      onChange={handlePasswordChange}
                      required
                    />
                    <label className={updateData.password ? "filled" : ""}>
                      Password
                    </label>
                    {isPasswordChanged && (
                      <p>Password field has been modified.</p>
                    )}
                  </div>

                  <div className="floating-label">
                    <select
                      className="form-select"
                      value={updateData.role}
                      onChange={(e) => {
                        setUpdateData({ ...updateData, role: e.target.value });
                      }}
                      required
                    >
                      <option value="">Select Role </option>
                      {getrole.map((item, index) => (
                        <option key={index} value={item._id}>
                          {item.rolename}
                        </option>
                      ))}
                    </select>
                    <label className={updateData.role ? "filled" : ""}></label>
                  </div>

                  <div className="floating-label">
                    <select
                      className="form-control"
                      value={updateData.status}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, status: e.target.value })
                      }
                    >
                      <option value="">Select Status</option>
                      <option value="Active">Active</option>
                      <option value="InActive">InActive</option>
                    </select>
                    <label
                      className={updateData.status ? "filled" : ""}
                    ></label>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={() => setUpdateShowModal(false)}
            >
              Cancel
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={handleupdatesubmit}
            >
              Update
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={ispreviewshowModal}
          onHide={() => setpreviewShowModal(false)}
          className="custom-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title id="modeti">User Preview</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  {empdetail && empdetail.length > 0 && (
                    <div className="floating-label">
                      <label className="form-label">
                        <b></b>
                      </label>
                      <select
                        className="form-select"
                        value={updateData.branch_id}
                        disabled
                        onChange={(e) => {
                          setUpdateData({
                            ...updateData,
                            branch_id: e.target.value,
                          }); // Update the state
                          handleAdditionalChanges(e); // Call the additional function here
                        }}
                        required
                      >
                        {responseDatas.map((item, index) => (
                          <option key={index} value={item.branch_id}>
                            {item.branch_id}
                          </option>
                        ))}
                      </select>
                      <label
                        className={updateData.branch_id ? "filled" : ""}
                      ></label>
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="text"
                      disabled
                      placeholder=""
                      value={updateData.username}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          username: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={updateData.username ? "filled" : ""}>
                      User Name
                    </label>
                  </div>
                </div>
                <div className="form-group">
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="email"
                      disabled
                      placeholder=""
                      value={updateData.email}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, email: e.target.value })
                      }
                      required
                    />
                    <label className={updateData.email ? "filled" : ""}>
                      Email
                    </label>
                  </div>
                </div>
                <div className="form-group">
                  <div className="floating-label">
                    <input
                      className="form-control"
                      placeholder=""
                      disabled
                      type="tel"
                      value={updateData.mobile}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, mobile: e.target.value })
                      }
                      required
                    />
                    <label className={addData.mobile ? "filled" : ""}>
                      Mobile
                    </label>
                  </div>
                </div>
                <div className="form-group">
                  <div className="floating-label">
                    <input
                      className="form-control"
                      placeholder=""
                      disabled
                      type="tel"
                      value={updateData.last_logout_time}
                      onChange={(e) =>
                        setUpdateData({
                          ...updateData,
                          last_logout_time: e.target.value,
                        })
                      }
                      required
                    />
                    <label className={addData.last_logout_time ? "filled" : ""}>
                      Logout Status
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="form-group">
                  {/* <div className="floating-label">
                                    <input className="form-control" placeholder='' type="text" value={updateData.designation[0]?.designation} onChange={(e) => setUpdateData({ ...updateData, designation: e.target.value })} required />
                                    <label className={updateData.designation ? "filled" : ""}>
                                        Designation
                                    </label>
                                </div> */}
                  {/* 
                <div className="floating-label">
                  <select
                    className="form-select"
                    value={designationnew}
                    onChange={(e) => {
                      setUpdateData({
                        ...updateData,
                        designation: e.target.value,
                      });
                    }}
                    required
                  >
             
                    {designation.map((item, index) => (
                      <option key={item._id} value={item._id}>
                        {item.designation}
                      </option>
                    ))}
                  </select>
                  <label
                    className={updateData.designation ? "filled" : ""}
                  ></label>
                </div> */}

                  <div className="floating-label mt-4">
                    <select
                      className="form-select"
                      value={updateData.designation}
                      disabled
                      onChange={(e) => {
                        setUpdateData({
                          ...updateData,
                          designation: e.target.value,
                        });
                      }}
                      required
                    >
                      {/* <option value="">Select Designation</option> */}
                      {designation.map((item) => (
                        <option key={item._id} value={item._id}>
                          {item.designation}
                        </option>
                      ))}
                    </select>
                    {/* <label className={updateData.designation ? "filled" : ""}>Designation</label> */}
                  </div>

                  {/* <div className="floating-label">
                  <input
                    className="form-control"
                    type="password"
                    placeholder=""
                    value={updateData.password}
                    onChange={(e) =>
                      setUpdateData({ ...updateData, password: e.target.value })
                    }
                    required
                  />
                  <label className={updateData.password ? "filled" : ""}>
                    Password12
                  </label>
                </div> */}
                </div>
                <div className="form-group mt-4">
                  <div className="floating-label">
                    <input
                      className="form-control"
                      type="password"
                      disabled
                      placeholder=""
                      value={updateData.password}
                      onChange={handlePasswordChange}
                      required
                    />
                    <label className={updateData.password ? "filled" : ""}>
                      Password
                    </label>
                    {isPasswordChanged && (
                      <p>Password field has been modified.</p>
                    )}
                  </div>
                </div>
                <div className="form-group">
                  <div className="floating-label">
                    <select
                      className="form-select"
                      value={updateData.role}
                      disabled
                      onChange={(e) => {
                        setUpdateData({ ...updateData, role: e.target.value });
                      }}
                      required
                    >
                      <option value="">Select Role </option>
                      {getrole.map((item, index) => (
                        <option key={index} value={item._id}>
                          {item.rolename}
                        </option>
                      ))}
                    </select>
                    <label className={updateData.role ? "filled" : ""}></label>
                  </div>
                </div>

                <div className="form-group mt-4">
                  <div className="floating-label">
                    <select
                      className="form-control"
                      disabled
                      value={updateData.status}
                      onChange={(e) =>
                        setUpdateData({ ...updateData, status: e.target.value })
                      }
                    >
                      <option value="">Select Status</option>
                      <option value="Active">Active</option>
                      <option value="InActive">InActive</option>
                    </select>
                    <label
                      className={updateData.status ? "filled" : ""}
                    ></label>
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={() => setpreviewShowModal(false)}
            >
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>

        {/* ----------------delete */}

        <Modal className="modal" show={showModals} onHide={handleCloseModal}>
          <Modal.Header>
            <p id="modeti">Are you sure you want to Delete?</p>
          </Modal.Header>
          <Modal.Body>
            <label className="form-label d-flex">
              <h5 className="mx-1"> User Name :</h5> <h5>{getdeletename} </h5>
            </label>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={handleCloseModal}
            >
              Close
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={handleDelete}
            >
              Delete
            </Button>
          </Modal.Footer>
        </Modal>

        {/* password change */}

        <Modal
          className="modal"
          show={showModalspassword}
          onHide={handleCloseModalpassword}
        >
          <Modal.Header>
            <p>Super Admin Password Change</p>
          </Modal.Header>
          <Modal.Body>
            <input type="text"></input>
            <label>Password</label>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="cancelbut"
              variant="secondary"
              onClick={handleCloseModalpassword}
            >
              Close
            </Button>
            <Button
              className="submitbut"
              variant="primary"
              onClick={handleDelete}
            >
              Delete
            </Button>
          </Modal.Footer>
        </Modal>

        {/* _------------------------------pagination button -------------------------------- */}

        <div className="mt-3 pb-5">
          <div className="row">
            <div className="col-lg-7 col-sm-12 mt-1">
              <span className="text-dark">
                Page {currentPage} of {totalPages}
              </span>
            </div>
            <div className="col-lg-5">
              <nav>
                <ul className="pagination justify-content-center">
                  {createPagination()}
                </ul>
              </nav>
            </div>
          </div>
        </div>

        {/* ---------------------------------------end ---------------------------------- */}
      </div>
    </>
  );
}

export default User;
